module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/google-755d3f7f.svg";